import React from "react";

const ShimmerVideoCard = ({ compact = false }) => {
  const thumbClass = compact ? "h-24" : "h-48 md:h-40";

  return (
    <div className={`flex flex-col ${compact ? 'mb-2' : 'mb-8'}`}>
      <div className={`relative ${thumbClass} rounded-xl overflow-hidden bg-slate-500/[0.4]`}>
        {/* Thumbnail shimmer */}
      </div>

      <div className="flex mt-3">
        <div className="flex items-start">
          <div className="flex h-9 w-9 rounded-full bg-slate-300/[0.4]"></div>
        </div>

        <div className="flex flex-col ml-3 w-full">
          <div className="bg-slate-400/[0.4] rounded-md h-4 w-3/4 md:w-2/3"></div>

          <div className="mt-2 flex items-center space-x-3">
            <div className="bg-slate-500/[0.4] rounded-md h-3 w-1/4 md:w-1/6"></div>
            <div className="bg-slate-500/[0.4] rounded-md h-3 w-1/6 md:w-1/8"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShimmerVideoCard;
